<template>
  <div>
    <breadcrumb v-bind:path2="path2"></breadcrumb>
    <div class="privacy">
      <div class="main-content">
        <div class="page-width pre-formatted">
          <div class="section-header text-center">
            <h1>{{ $t('privacyTitle') }}</h1>
          </div>
          <p v-html="$t('privacyBody')"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumb from '../components/breadcrumb'
import { Config } from '../../config/default';
export default {
  name: "privacy",
  components: {
    breadcrumb,
  },
  data() {
    return {
      companyPrivacyPolicy: Config.COMPANY_PRIVACY_POLICY,
      path2: this.$t('privacyTitle'),
    }
  }
}
</script>

<style scoped lang="less">
@import "../assets/css/public.less";
@import "../assets/css/privacy.less";
</style>



// WEBPACK FOOTER //
// src/view/privacy.vue